import { useHistory } from "react-router-dom";
import { BillingProvider } from "../../context/BillingContext";
import useSubscription from "../../hooks/useSubscription";
import { StepManager } from "./StepManager";
import { useEffect } from "react";
import useAuth from "../../hooks/useAuth";

export function Billing() {
  const { isUserPremiumUncached } = useSubscription();
  const { push } = useHistory();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    async function determineCanContinue() {
      const isUserAuthenticated = isAuthenticated();
      const isAlreadyPremium = await isUserPremiumUncached();

      if (!isUserAuthenticated) {
        return window.location.replace("/login");
      } else if (isAlreadyPremium) {
        localStorage.removeItem("is_premium_valid");
        return push("/welcome");
      }
    }

    determineCanContinue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BillingProvider>
      <StepManager />
    </BillingProvider>
  );
}
